// Simple and reliable email regex pattern
export const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
export const phoneNumberPattern = /[^0-9+\-]/g // only digits and + sign
export const removeLeadingSlashPattern = /^\//
export const cleanPathPattern = /^\/+|\/+$/g

// Used in sanityLoader.ts
export const globalSuffixPattern = /-(mini|small|medium|big|full|original)/gi
export const lastSuffixPattern = /-(mini|small|medium|big|full|original)$/i

export const wildcardSegmentPattern = /:\w+\*/g // matches dynamic segments like :path*
export const dynamicSegmentPattern = /:\w+/g // matches dynamic segments like :path
export const wildcardSegmentWithSlashPattern = /\/:\w+\*/g // Handle `/:path*` — optional slash + capture so bare paths match too
